import React, { useEffect, useMemo, useState } from "react";
import { apiClient } from "../../utils/apiClient.js";
import { useNavigate } from "react-router-dom";
import {
  Tabs,
  Card,
  Checkbox,
  Button,
  Typography,
  Avatar,
  Radio,
  message,
  Spin,
} from "antd";
import { BellOutlined } from "@ant-design/icons";
import styled from "@emotion/styled";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import TuneIcon from "@mui/icons-material/Tune";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { URL } from "../../helper/Mainurl.js";
import { ReactComponent as LogoShare } from "../../Assets/Dashboardimages/logoShare.svg";
import { ReactComponent as Reminder } from "../../Assets/Dashboardimages/Reminder.svg";
import FilterModal from "../Modals/Dashboard/FilterModalWithoutColor.jsx";
import RecurringEventModal from "../Modals/DeleteAndUpdateModal/DeleteAndUpdateModal.jsx";
import DeleteConfirmationModal from "../../Pages/DeleteConfirmationModal.jsx";
const { Text, Title } = Typography;

// Styled Components
const TasksSectionContainer = styled(Card)`
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  .ant-card-head {
    border: none;
    padding: 16px 24px;
  }
  .ant-card-body {
    padding: 0 24px 24px;
  }

  @media (max-width: 576px) {
    .ant-card-head {
      padding: 12px 16px;
    }
    .ant-card-body {
      padding: 0 16px 16px;
    }
  }
`;

const PriorityTag = styled.div`
  position: absolute;
  top: 12px;
  left: -10px;
  border: none;
  border-radius: 5px;
  padding: 4px 8px;
  font-weight: 400;
  color: white;
  font-size: 13px;
  border-bottom-left-radius: 0;
  background-color: ${({ priority }) =>
    priority === "high"
      ? "#FF2828"
      : priority === "medium"
      ? "#F59E0B"
      : priority === "low"
      ? "#1EC940"
      : "#9CA3AF"};

  z-index: 2;

  &::after {
    content: "";
    position: absolute;
    bottom: -10px;
    left: 0px;
    width: 10px;
    height: 10px;
    background-color: ${({ priority }) =>
      priority === "high"
        ? "#CF0505"
        : priority === "medium"
        ? "#D97706"
        : priority === "low"
        ? "#128329"
        : "#6B7280"};
    border-bottom-left-radius: 130%;
    z-index: 1;
  }
`;

const TaskCard = styled.div`
  background-color: ${(props) =>
    props.isEvent
      ? "#ffeeef"
      : props.priority === "high"
      ? "#FEF1FE"
      : props.priority === "medium"
      ? "#FFF9E6"
      : props.priority === "low"
      ? "#E6F4FF"
      : "#F5F5F5"};
  padding: 16px;
  border-radius: 12px;
  margin-bottom: 12px;
  position: relative;
  word-break: break-word;
`;

const TaskTitle = styled.div`
  font-weight: 600;
  font-size: 20px;
  margin-top: ${(props) => (props.isEvent ? "0px" : "34px")};
  margin-bottom: 4px;
  color: #1d2433;

  @media (max-width: 576px) {
    font-size: 18px;
    margin-top: ${(props) => (props.isEvent ? "0px" : "24px")};
  }
`;

const TaskDescription = styled.div`
  color: #767a83;
  font-size: 14px;
  margin-bottom: 12px;
`;

const TimeDisplay = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #1d2433;
  font-size: 14px;
`;

const ProgressBarContainer = styled.div`
  height: 10px;
  background-color: #ffffff;
  border-radius: 6px;
  margin: 12px 0;
  position: relative;
  width: calc(100% - 30px);
  display: flex;
  align-items: center;
  padding: 0 2px;
`;

const ProgressText = styled.span`
  position: absolute;
  right: -30px;
  font-size: 12px;
  color: #9a4fe0;
`;

const ProgressInner = styled.div`
  height: 6px;
  width: ${({ progress }) => `${progress}%`};
  background-color: #9a4fe0;
  border-radius: 5px;
`;

const TaskFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0px;

  .delete-button-icon {
    color: #8c8c8c; /* gray default */
    font-size: 20px;
    transition: color 0.3s;
  }

  .delete-button:hover .delete-button-icon {
    color: #ff4d4f; /* red on hover */
  }
`;

const TaskBadge = styled.div`
  background-color: ${({ color }) => color || "#8B5CF6"};
  color: ${({ textColor }) => textColor || "#FFFFFF"};
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 400;
  margin-right: 8px;
`;

const AvatarGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const StyledTabsWrapper = styled.div`
  .ant-tabs-tab {
    font-size: 14px;
    font-weight: 600;
    padding: 6px 10px;
    position: relative;
    transition: color 0.3s;
    color: #767a83;
  }

  .ant-tabs-tab.ant-tabs-tab-active {
    color: #9a4fe0 !important;
  }

  .ant-tabs-tab.ant-tabs-tab-active::after {
    content: "";
    position: absolute;
    left: 16px;
    right: 16px;
    bottom: 0;
    height: 3px;
    background-color: #9a4fe0;
    border-radius: 2px;
  }

  .ant-tabs-ink-bar {
    display: none !important;
  }
`;

const FiltersWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  padding: 16px 20px;
  justify-content: flex-end;
  background-color: #f3f4f6;
  border-radius: 12px;
  // margin-bottom: 16px;

  @media (max-width: 992px) {
    justify-content: flex-start;
  }

  @media (max-width: 576px) {
    flex-direction: column;
    gap: 12px;
    padding: 12px 16px;
  }
`;

const FilterButton = styled(Button)`
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  padding: 0 12px;
  font-size: 14px;
  font-weight: 500;
  border-color: ${({ $active }) =>
    $active ? "#6366F1" : "#d9d9d9"} !important;
  color: ${({ $active }) => ($active ? "#6366F1" : "#1F2937")} !important;
  background-color: #fff;

  @media (max-width: 576px) {
    width: 100%;
    justify-content: center;
  }
`;

const StyledCheckbox = styled(Checkbox)`
  .ant-checkbox-inner {
    border: 2px solid #767a83 !important;
    border-radius: 4px;
    width: 18px;
    height: 18px;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #1f2937;
    border-color: #1f2937;
  }

  .ant-checkbox + span {
    font-weight: 600;
    color: #1f2937;
  }
`;

const WhiteHr = styled.hr`
  border: none;
  border-top: 1px solid white;
  margin: 4px 0;
`;

const StyledModalWrapper = styled.div`
  position: relative;
  padding: 24px;
`;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const FilterSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const SectionTitle = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #1d2433;
`;

const StyledRadioGroup = styled(Radio.Group)`
  width: 100%;
  .ant-radio-wrapper {
    margin-right: 16px;
    margin-bottom: 8px;
  }
`;

const ActionButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 24px;
`;

const OutsideCloseButton = styled.div`
  position: absolute;
  top: -48px;
  right: -22px;
  background: white;
  border-radius: 50%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1000;
`;

const TasksSection = () => {
  const [activeTab, setActiveTab] = useState("Today");
  const [active, setActive] = useState("");
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [selectedPriority, setSelectedPriority] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  // const [selectedType, setSelectedType] = useState(["task", "event"]);
  const [selectedType, setSelectedType] = useState([]);

  const [tasks, setTasks] = useState({
    Yesterday: [],
    Today: [],
    Tomorrow: [],
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [selectedItemForDelete, setSelectedItemForDelete] = useState(null);

  const priorityOptions = [
    { key: "Low", label: "Low" },
    { key: "Medium", label: "Medium" },
    { key: "High", label: "High" },
  ];

  const statusOptions = [
    { key: "Pending", label: "Pending" },
    { key: "Completed", label: "Completed" },
    { key: "Not Started", label: "Not Started" },
  ];

  const fetchTasks = async () => {
    setLoading(true);
    try {
      const response = await apiClient.get(`/v1/calendar/dash-calendar-data`, {
        type:
          selectedType.includes("task") && selectedType.includes("event")
            ? null
            : selectedType[0],
        dateFilter: activeTab,
        priority: selectedPriority,
        status: selectedStatus,
      });
      

      const groupedData = {
        Yesterday: response.data.data.Yesterday || [],
        Today: response.data.data.Today || [],
        Tomorrow: response.data.data.Tomorrow || [],
      };

      setTasks(groupedData);
    } catch (err) {
      setError("Failed to load tasks.");
      message.error("Failed to load tasks. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const formatTime = (startTime, endTime) => {
    const start = new Date(startTime);
    const end = new Date(endTime);

    const startStr = start.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      timeZone: "UTC",
    });

    const endStr = end.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      timeZone: "UTC",
    });

    return `${startStr} - ${endStr}`;
  };

  // useEffect(() => {
  //   fetchTasks();
  // }, [activeTab, selectedPriority, selectedStatus, selectedType]);

  useEffect(() => {
    fetchTasks();
  }, [selectedType]);

  // console.log("taskstasks", activeTab, tasks);

  const handleFilterApply = (filters) => {
    // console.log("filtershandleFilterApply", filters);
    setSelectedPriority(filters.priority);
    setSelectedStatus(filters.status);
    setSelectedType(filters.types);
  };

  const getPriorityLabel = () => {
    if (!selectedPriority) return "Priority";
    const option = priorityOptions.find((p) => p.key === selectedPriority);
    return option ? option.label : "Priority";
  };

  const getStatusLabel = () => {
    if (!selectedStatus) return "Status";
    const option = statusOptions.find((s) => s.key === selectedStatus);
    return option ? option.label : "Status";
  };

  const buttons = [
    {
      label: "Filters",
      icon: <TuneIcon style={{ marginRight: 6, fontSize: 20 }} />,
      onClick: () => {
        setActive("Filters");
        setIsFilterModalOpen(true);
      },
    },
    {
      label: getPriorityLabel(),
      icon: <KeyboardArrowDownIcon style={{ fontSize: 20 }} />,
      onClick: () => {
        setActive("Priority");
        setIsFilterModalOpen(true);
      },
    },
    {
      label: getStatusLabel(),
      icon: <KeyboardArrowDownIcon style={{ fontSize: 20 }} />,
      onClick: () => {
        setActive("Status");
        setIsFilterModalOpen(true);
      },
    },
  ];

  const formatTasks = (items = []) => {
    const getProgressFromStatus = (status) => {
      switch (status) {
        case "Completed":
          return 100;
        case "Pending":
          return 50;
        case "Not Started":
          return 0;
        default:
          return 0; // Default value for any other status
      }
    };

    // console.log("formTaskItems", items);
    return items.map((item) => ({
      id: item.id,
      title: item.title,
      description: item.description,
      time: item.start_time ? formatTime(item.start_time, item.end_time) : "",
      priority: item.priority_label?.toLowerCase() || "No Priority",
      type: item.type === "task" ? "Task" : "Event",
      status: item.status_label,
      start_date: item.start_date,
      progress: getProgressFromStatus(item.status_label),
      color: item.color_id,
      event_master_id: item.event_master_id,
      task_master_id: item.task_master_id,
    }));
  };

  const filteredTasks = useMemo(() => {
    const filterItems = (items) =>
      items.filter((item) => {
        const matchesPriority = selectedPriority
          ? item.priority_label === selectedPriority
          : true;
        const matchesStatus = selectedStatus
          ? item.status_label === selectedStatus
          : true;
        return matchesPriority && matchesStatus;
      });

    return {
      Yesterday: filterItems(tasks.Yesterday || []),
      Today: filterItems(tasks.Today || []),
      Tomorrow: filterItems(tasks.Tomorrow || []),
    };
  }, [selectedPriority, selectedStatus, tasks]);

  // Task/ event deletion with master id
  const deleteTaskById = async (
    type,
    taskId,
    occurrenceDate = "2025-06-04",
    deleteType = "all"
  ) => {
    try {
      const token = localStorage.getItem("authToken");
      const payload = {
        delete_type: deleteType,
        ...(deleteType !== "all" && { occurrence_date: occurrenceDate }),
      };
      const response = await axios.delete(
        `${URL}/v1/${type.toLowerCase()}/delete/${taskId}`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          data: payload,
        }
      );

      message.success(`${type} deleted successfully`);
      return response.data;
    } catch (error) {
      message.error(`Error deleting ${type}`);
      console.error("Error deleting task:", error);
      throw error;
    }
  };

  const handleDeleteTaskEvent = (type, taskOReventId, occurrenceDate) => {
    setSelectedItemForDelete({
      type,
      id: taskOReventId,
      occurrenceDate,
    });
    setDeleteModalVisible(true);
  };

  const handleDeleteConfirm = async (payload) => {
    try {
      const { type, id, occurrenceDate } = selectedItemForDelete;
      await deleteTaskById(type, id, occurrenceDate, payload.update_type);
      // message.success("Item deleted successfully");
      fetchTasks(); // Refresh the tasks list
    } catch (error) {
      message.error("Failed to delete item");
      console.error("Error deleting item:", error);
    }
  };

  const renderTaskCard = (task) => {
    // console.log("tasktasktasktask", task);
    return (
      <TaskCard
        key={task.id}
        priority={task.priority}
        isEvent={task.type === "Event"}
      >
        {/* <div style={{ position: "absolute", right: 22, top: 54 }}>
          <StyledCheckbox checked={task.progress === 100}></StyledCheckbox>
        </div> */}

        {/* <PriorityTag priority={task.priority}>
          {task.priority.charAt(0).toUpperCase() + task.priority.slice(1)}{" "}
          Priority
        </PriorityTag> */}
        {/* Only render PriorityTag for tasks */}
        {/* {task.type !== "Event" && ( */}
        <PriorityTag priority={task.priority}>
          {task?.priority == "no priority"
            ? "No Priority"
            : `${
                task.priority.charAt(0).toUpperCase() + task.priority.slice(1)
              } Priority`}
        </PriorityTag>
        {/* )} */}

        <TaskTitle>{task.title}</TaskTitle>
        <TaskDescription>{task.description}</TaskDescription>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: 8,
          }}
        >
          {task.time && (
            <TimeDisplay>
              {task.time} <BellOutlined />
            </TimeDisplay>
          )}

          {task.assignee && (
            <AvatarGroup>
              <Avatar.Group maxCount={3} size="small">
                <Avatar style={{ backgroundColor: "#8B5CF6" }}>S</Avatar>
                <Avatar style={{ backgroundColor: "#EC4899" }}>J</Avatar>
                <Avatar style={{ backgroundColor: "#F59E0B" }}>M</Avatar>
              </Avatar.Group>
            </AvatarGroup>
          )}
        </div>

        {/* {task.progress > 0 && ( */}
        <ProgressBarContainer>
          <ProgressInner progress={task.progress} />
          <ProgressText>{task.progress}%</ProgressText>
        </ProgressBarContainer>
        {/* )} */}

        <WhiteHr />

        <TaskFooter>
          <TaskBadge
            color={
              task.type === "Task"
                ? "#9A4FE0"
                : task.type === "Reminder"
                ? "#82ACFF"
                : "#FF6FB5"
            }
          >
            {task.type}
          </TaskBadge>

          <TaskBadge color="#FFFFFF" textColor="#9A4FE0">
            {task.status}
          </TaskBadge>

          {/* <Button
            type="text"
            className="delete-button"
            icon={<DeleteOutlined className="delete-button-icon" />}
            onClick={() =>
              handleDeleteTaskEvent(
                task.type,
                task.event_master_id || task.task_master_id,
                task.start_date
              )
            }
            style={{ marginLeft: "auto" }}
          /> */}
        </TaskFooter>
      </TaskCard>
    );
  };
  return (
    <div>
      {/* Filter Buttons */}
      <FiltersWrapper>
        {buttons.map(({ label, icon, onClick }) => (
          <FilterButton
            key={label}
            onClick={onClick}
            icon={icon}
            $active={active === label}
          >
            {label}
          </FilterButton>
        ))}
      </FiltersWrapper>

      {/* Filter Modal */}
      <FilterModal
        isFilterModalOpen={isFilterModalOpen}
        closeFilterModal={() => setIsFilterModalOpen(false)}
        applyFilters={handleFilterApply}
        initialPriority={selectedPriority}
        initialStatus={selectedStatus}
      />

      {/* Task List */}
      <TasksSectionContainer
        title={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Title
              level={4}
              style={{ margin: 0, fontSize: 22.8, color: "#54536E" }}
            >
              Recent Tasks/events
            </Title>
            <Button
              type="link"
              onClick={() => navigate("/calender")}
              style={{ color: "#9A4FE0", fontWeight: 600, fontSize: 14 }}
            >
              See all
            </Button>
          </div>
        }
      >
        <StyledTabsWrapper>
          <Tabs
            activeKey={activeTab}
            onChange={setActiveTab}
            items={[
              { label: "Yesterday", key: "Yesterday" },
              { label: "Today", key: "Today" },
              { label: "Tomorrow", key: "Tomorrow" },
            ]}
          />
        </StyledTabsWrapper>

        {loading ? (
          <div style={{ textAlign: "center", padding: "24px" }}><Spin size="small" /></div>
        ) : error ? (
          <div
            style={{ textAlign: "center", padding: "24px", color: "#ff4d4f" }}
          >
            {error}
          </div>
        ) : !tasks[activeTab] || tasks[activeTab].length === 0 ? (
          <div
            style={{ textAlign: "center", padding: "24px", color: "#767a83" }}
          >
            No tasks found matching your filters
          </div>
        ) : (
          // [activeTab]
          // tasks.map(renderTaskCard)
          // formatTasks(tasks[activeTab]).map(renderTaskCard)
          formatTasks(filteredTasks[activeTab]).map(renderTaskCard)
        )}
      </TasksSectionContainer>

      {/* Modal for delete/update type  */}
      <RecurringEventModal
        visible={deleteModalVisible}
        action="delete"
        occurrenceDate={selectedItemForDelete?.occurrenceDate}
        onClose={() => setDeleteModalVisible(false)}
        onConfirm={handleDeleteConfirm}
      />
      {/* {isModalVisible && (
        <DeleteConfirmationModal
          visible={isModalVisible}
          onConfirm={handleConfirmDelete}
          onCancel={() => setIsModalVisible(false)}
        />
      )} */}
    </div>
  );
};

export default TasksSection;
